// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { StatusChip, StatusChipProps } from '@/components/status-chip';
import { ExchangeOrderEntityStatus } from '@/exchange-order/api/types';

/**
 * Chip styling for each exchange order status.
 */
const EXCHANGE_ORDER_STATUS_CHIP_CONFIG: Record<
  ExchangeOrderEntityStatus,
  StatusChipProps
> = {
  draft: { variant: 'outlined', color: 'default', label: 'Draft' },
  in_progress: { variant: 'filled', color: 'warning', label: 'In progress' },
  complete: { variant: 'filled', color: 'primary', label: 'Complete' },
  cancelled: { variant: 'outlined', color: 'error', label: 'Cancelled' },
};

interface ExchangeOrderStatusChipProps {
  status: ExchangeOrderEntityStatus;
}

/**
 * Status chip for exchange orders.
 */
export function ExchangeOrderStatusChip(props: ExchangeOrderStatusChipProps) {
  const config = EXCHANGE_ORDER_STATUS_CHIP_CONFIG[props.status];
  return <StatusChip {...config} />;
}
